"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Off = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Off"));

// Generated by script, don't edit it please.
var Off = (0, _createSvgIcon["default"])({
  as: _Off["default"],
  ariaLabel: 'off',
  category: 'action',
  displayName: 'Off'
});
var _default = Off;
exports["default"] = _default;
module.exports = exports.default;